<span class="color-amber" style="font-weight: bold;" [hidden]="!errorCounts">{{errorCounts}}</span>